<template>
    <div class="section contact grid">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <div class="contact--wrap">
            <div class="grid--row">
                <div class="grid--col contact--col">
                    <cmp-contact-link-list facet="dark" :entries="contentLinks[0]"></cmp-contact-link-list>
                </div>
                <div class="grid--col contact--col" v-if="hasOpeningHours">
                    <h2 class="u-reset contact--opening-hours-title" v-text="content.opening_hours.title"></h2>
                    <div class="contact--opening-hours-text" v-html="content.opening_hours.text"></div>
                </div>
                <div class="grid--col contact--col" v-if="!hasOpeningHours && !isMobile">
                    <cmp-contact-link-list facet="dark" :entries="contentLinks[1]"></cmp-contact-link-list>
                </div>
                <div class="grid--col contact--col">
                    <component class="contact--modular-content"
                            v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                            :is="plugin.type"
                            :plugin="plugin">
                    </component>
                </div>
                <div class="grid--col contact--col contact--col__wide">
                    <cmp-map class="contact--maps" :mapId="content.map.map_id" :lat="content.map.lat" :lng="content.map.lng" :name="content.map.name" :formattedAddress="content.map.formatted_address"></cmp-map>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import { mapFilters } from 'util/vue/map-filters';
    import { toNumeral, numerals } from 'util/dom/mq';


    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            ...mapGetters(['viewport']),
            isMobile() {
                return toNumeral(this.viewport.mq.query) < numerals.MD;
            },
            hasOpeningHours() {
                return !!this.content.opening_hours;
            },
            contentLinks() {
                const links = this.content.links;

                return [
                    links.slice(0, (this.hasOpeningHours || this.isMobile) ? links.length : 1),
                    (this.hasOpeningHours || this.isMobile) ? null : links.slice(1, links.length),
                ];
            },
        },
        methods: {
            ...mapFilters(['linebreak']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?479aa42e